import React, { useState } from 'react';
import { Send, Smile, Loader } from 'lucide-react';

const MessageInput = ({ onSendMessage, disabled = false, isLoading = false }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !disabled && !isLoading) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="border-t border-gray-200 bg-white p-4">
      <div className="flex items-end space-x-2">
        {/* Message Input */}
        <div className="flex-1 relative">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Type your message..."
            className="block w-full px-4 py-3 bg-[#E8ECF5] border-0 rounded-xl shadow-neomorph-inset text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500/50 resize-none min-h-[60px] max-h-32 pr-12"
            disabled={disabled || isLoading}
            rows="2"
          />
          
          {/* Emoji Picker (placeholder) */}
          <button
            type="button"
            disabled={disabled || isLoading}
            className="absolute right-3 bottom-3 p-1.5 bg-white rounded-lg shadow-neomorph hover:shadow-neomorph-hover transition-all text-gray-400 hover:text-primary-600 disabled:opacity-50"
            title="Add emoji"
          >
            <Smile className="h-4 w-4" />
          </button>
        </div>

        {/* Send Button */}
        <button
          type="submit"
          disabled={disabled || isLoading || !message.trim()}
          className="bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-xl shadow-md shadow-primary-500/30 hover:shadow-lg hover:shadow-primary-500/40 transition-all w-12 h-12 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? (
            <Loader className="h-5 w-5 animate-spin" />
          ) : (
            <Send className="h-5 w-5" />
          )}
        </button>
      </div>

      {/* Tips */}
      <p className="text-xs text-gray-400 mt-2 ml-1">
        Press Enter to send, Shift+Enter for new line
      </p>

      <style jsx>{`
        .shadow-neomorph {
          box-shadow: 6px 6px 11px #d0d6e0, -6px -6px 11px #ffffff;
        }
        .shadow-neomorph-hover {
          box-shadow: 4px 4px 7px #d0d6e0, -4px -4px 7px #ffffff;
        }
        .shadow-neomorph-inset {
          box-shadow: inset 2.5px 2.5px 5px #d0d6e0, inset -2.5px -2.5px 5px #ffffff;
        }
      `}</style>
    </form>
  );
};

export default MessageInput;